// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"89b8b3b6","513":"219701a5"}[chunkId] + ".chunk.js";
};